import { render, staticRenderFns } from "./5RankingList.vue?vue&type=template&id=2744fd1a&scoped=true&"
import script from "./5RankingList.vue?vue&type=script&lang=js&"
export * from "./5RankingList.vue?vue&type=script&lang=js&"
import style0 from "./5RankingList.vue?vue&type=style&index=0&id=2744fd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744fd1a",
  null
  
)

export default component.exports